var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.label,"items":_vm.choices,"value":_vm.value,"return-object":""},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }